import { render, staticRenderFns } from "./GSideNavigationLayout.vue?vue&type=template&id=1ba84290&"
import script from "./GSideNavigationLayout.vue?vue&type=script&lang=ts&"
export * from "./GSideNavigationLayout.vue?vue&type=script&lang=ts&"
import style0 from "./GSideNavigationLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports